<dynamic-form
  [group]="formGroup"
  [label]="'ClientApp.FrontOffice.Order.OrderOnline.CauseCancel.CauseCancel' | translate"
  (cancelChange)="cancel()"
  (submitChange)="save()">
  <ng-container class="content">
    <div class="page">
      <ssg-select
        name="causeCancelId"
        class="pricemodel"
        [group]="formGroup"
        [searchable]="false"
        [selectOnTab]="false"
        [clearable]="false"
        [dataList]="Causecancel"
        textFieldName="title"
        valueFieldName="Id"
        [label]="'ClientApp.FrontOffice.Order.OrderOnline.ReasonCall' | translate"></ssg-select>
    </div>
  </ng-container>
</dynamic-form>
